var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDivider2 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 21,
  fill: "none",
  viewBox: "0 0 19 21",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5DEEB",
  d: "M14.993 11.064c-1.45 1.864-4.099 4.66-5.9 6.406-1.8-1.746-4.83-4.172-6.242-6.066-.338-.453 4.823-6.367 6.409-8.372 1.585 2.005 6.59 6.931 5.733 8.032M10.278.656c-.794-.679-1.469-.793-2.368 0C5.93 2.398-.436 9.96.042 11.342c1.19 3.44 5.837 6.894 8.206 9.339.287.296.58.366.846.291.266.075 7.861-6.19 9.052-9.63.478-1.382-5.865-8.974-7.868-10.686"
})));
export default SvgDivider2;